<template>
  <div class="make-a-difference-card">
    <div class="display-progress-numbers">
      <h2>{{ title }}</h2>

      <DisplayProgressBar
        :percentage="percentage"
      ></DisplayProgressBar>

      <div class="content">
        <div class="quantity">
          <div>{{ signedUpQuantity }}</div>
          <p>{{ sigupMessage }}</p>
        </div>

        <div class="separator">
          <div class="bar"></div>
        </div>

        <div class="quantity">
          <div>{{ neededToReach }}</div>
          <p>{{ goalMessage }} {{ getPetitionGoal }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayProgressBar from './DisplayProgressBar.vue';
import firebase from "firebase";

export default {
  name: 'DisplayProgressNumbers',
  components: {
    DisplayProgressBar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    sigupMessage: {
      type: String,
      required: true,
    },
    goalMessage: {
      type: String,
      required: true,
    },
    datalayerName: {
      type: String,
      required: true,
    },
    petitionGoal: {
      type: Number,
    },
  },
  data() {
    return {
      petitionCount: 0,
    };
  },
  async created() {
    firebase
      .firestore()
      .collection("campaigns")
      .doc(this.datalayerName)
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          if (!!data) {
            this.petitionCount = data.count;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  },
  computed: {
    signedUpQuantity() {
      return this.petitionCount.toLocaleString('en-AU');
    },
    neededToReach() {
      if (this.petitionCount >= this.petitionGoal) {
        return 0;
      }

      return (this.petitionGoal - this.petitionCount).toLocaleString('en-AU');
    },
    percentage() {
      if (this.petitionCount >= this.petitionGoal) {
        return 100;
      }

      if (this.petitionCount === 0 || this.petitionGoal === 0) {
        return 0;
      }

      return this.petitionCount * 100 /  this.petitionGoal;
    },
    getPetitionGoal() {
      return this.petitionGoal.toLocaleString('en-AU');
    }
  },
}
</script>

<style scoped>
.make-a-difference-card {
  border-radius: 20px;
  border: 0.5px solid rgba(50, 50, 50, 0.25);
  background: #FAFAFA;
  max-width: 1216px;
  padding: 56px 32px;
  margin: 0 auto;
}
.display-progress-numbers {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 43px;
}

.display-progress-numbers h2,
.display-progress-numbers .content .quantity div {
  font-family: "WWF",sans-serif;
}

.display-progress-numbers h2 {
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.display-progress-numbers .content {
  display: flex;
  align-content: flex-start;
  gap: 125px;
}

.display-progress-numbers .content .quantity {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.display-progress-numbers .content .quantity div {
  font-size: 64px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -1.472px;
}

.display-progress-numbers .content .quantity p {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.414px;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
}

.display-progress-numbers .content .separator {
    display: flex;
    align-items: center;
}

.display-progress-numbers .content .separator .bar{
    border: 0.5px solid #dadada;
    height: 110px;
}

@media screen and (max-width: 1250px) {
  .make-a-difference-card {
    margin: 0 24px 0;
    padding: 16px 10px;
  }

  .display-progress-numbers {
    gap: 10px;
  }

  .display-progress-numbers h2 {
    font-size: 29px;
  }

  .display-progress-numbers .content {
    gap: 10px;
  }

  .display-progress-numbers .content .quantity div {
    font-size: 47px;
  }

  .display-progress-numbers .content .quantity p {
    font-size: 12px;
  }

  .display-progress-numbers .content .separator .bar{
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// DisplayProgressNumbers.vue?62757487